import React from 'react'
import { prop } from 'ramda'

import * as API from '~/constants/api'
import SearchField from '~/components/Fields/SearchField'

const getOptionLabel = item => {
  if (item) {
    const firstName = prop('firstName', item)
    const lastName = prop('lastName', item)
    return `${firstName} ${lastName}`
  }

  return ''
}

const getOptionValue = item => {
  if (item) {
    const id = prop('id', item)
    const guid = prop('guid', item)
    const firstName = prop('firstName', item)
    const lastName = prop('lastName', item)

    return { id, guid, firstName, lastName }
  }

  return null
}

function UserSearchField (props) {
  return (
    <SearchField
      name="user"
      label="User"
      api={API.USER_LIST}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
      {...props}
    />
  )
}

export default UserSearchField
